// React Third Party Library
import { Col, Drawer, Form, Input, Row, Select, InputNumber } from "antd";
import { useDispatch, useSelector } from "react-redux";
import {
  LockOutlined,
} from "@ant-design/icons";

// Constants Library
import { ROOT_CONSTANT } from "../../../../constants";

// Components Library
import { BtnSubmit, ButtonLink, Options } from "../../../../components";

// Handler Library

// Services Library
import { REDUX as REDUX_UTIL } from "../../../../services/util";

// Redux Library
import * as REDUX_ACTION from "../../../../services/redux/actions";

// Styles Library

const { reduxStoreWrapper } = REDUX_UTIL;
const { icon_malaysia } = ROOT_CONSTANT.IMG.ICON.COUNTRY;

const DrawerEmployer = (props) => {
  const { isOpen, setIsOpen, type, form, handleSave } = props;
  const dispatch = useDispatch();

  const company = useSelector(reduxStoreWrapper("company.byID"));

  const optionsCompany = company
  ? Object.values(company)
      .filter((g) => g.status === 1 || g.status === 2)
      .map((g) => ({
        value: g.coid,
        label: g.name,
      }))
  : [];

  const formatInput = (value) => {
    if (!value) return ' ';
    return `${value}`.replace(/\D/g, '');
  };

  const parseInput = (value) => {
    return parseInt(value || ' ', 10);
  };

  const handleKeyPress = (e) => {
    const charCode = e.which ? e.which : e.keyCode;
    if (charCode > 31 && (charCode < 48 || charCode > 57)) {
      e.preventDefault();
    }
  };

  const ActionButton = (
    <Form.Item style={{ paddingTop: "20px" }}>
      <div>
        <BtnSubmit
          display="inline-block"
          text={type === "create" ? "Create" : "Save"}
          bgColor="#0E2483"
          color="white"
          width={type === "edit" ? "170px" : ""}
          padding="9px 18px"
          onClick={() => {
            handleSave();
            setIsOpen(false);
          }}
        />
        {type === "create" && (
          <BtnSubmit
            display="inline-block"
            text="Create & add Another"
            bgColor="#0E2483"
            color="white"
            padding="9px 15px"
            onClick={() => {
              form.resetFields();
            }}
          />
        )}
        <BtnSubmit
          display="inline-block"
          text="Cancel"
          bgColor="transparent"
          color="#c8c8c8"
          padding="9px 18px"
          border="1px solid #c8c8c8"
          width={type === "edit" ? "170px" : ""}
          onClick={() => {
            setIsOpen(false);
            // form.resetFields();
          }}
        />
      </div>
    </Form.Item>
  );

  return (
    <>
      <Drawer
        title={type === "create" ? "Create Employer" : "Edit Employer"}
        open={isOpen}
        onClose={() => setIsOpen(false)}
        width={410}
        closable={false}
        style={{
          textAlign: "center",
          fontSize: "15px",
        }}
        footer={ActionButton}
      >
        <Form form={form} layout="vertical">
          <Row>
            <Col
              style={{
                color: "#c8c8c8",
                alignItems: "center",
                fontSize: "15px",
                marginBottom: "20px",
                marginLeft: "2%",
                fontWeight: "400",
              }}
            >
              Employer Information
            </Col>
            {type === "edit" && (
              <Col
                style={{
                  width: "100%",
                  marginTop: "10px",
                }}
              >
                <>
                  <label htmlFor="memid" className="labelInput">
                    Employer ID <span style={{ color: "red" }}>*</span>
                  </label>
                  <Form.Item
                    name="memid"
                    rules={[
                      {
                        required: true,
                        message: "Employee ID is required",
                      },
                    ]}
                  >
                    <Input
                      readOnly
                      className="inputForm"
                      suffix={<LockOutlined style={{ color: "#D9D9D9" }} />}
                    />
                  </Form.Item>
                </>
              </Col>
            )}
          </Row>
          <Row>
            <Col
              style={{ width: "100%", marginTop: "10px" }}
            >
              <label htmlFor="name" className="labelInput">
                Employer Name <span style={{ color: "red" }}>*</span>
              </label>
              <Form.Item
                name="name"
                rules={[
                  {
                    required: true,
                    message: "Employer Name is required",
                  },
                ]}
              >
                <Input className="inputForm" />
              </Form.Item>
            </Col>
          </Row>
          <Row>
          <Col style={{ width: "100%", marginBottom: "10px" }}>
                <>
                  <label htmlFor="coName" className="optionLabel">
                    Company Name <span style={{ color: "red" }}>*</span>
                  </label>
                  <Form.Item
                    name="coid"
                    rules={[
                      {
                        required: true,
                        message: "Employee company is required",
                      },
                    ]}
                  >
                    <Select
                      suffixIcon={
                        type === "create" ? (
                          <span style={{ color: "#0E2483", fontSize: "16px" }}>
                            Select
                          </span>
                        ) : (
                          <LockOutlined style={{ color: "#D9D9D9" }} />
                        )
                      }
                      style={{
                        position: "relative",
                        marginTop: "11px",
                        marginLeft: "5px",
                        borderRadius: "var(--br-3xs)",
                        height: "40px",
                        width: "100%",
                        textAlign: "left",
                        background: type === "edit" && "white"
                      }}
                      disabled={type === "edit"}
                    >
                      {optionsCompany.map((option) => (
                        <Select.Option
                          key={option.value}
                          value={option.value}
                          style={{
                            color: "black",
                          }}
                        >
                          {option.label}
                        </Select.Option>
                      ))}
                    </Select>
                  </Form.Item>
                </>
            </Col>
          </Row>
          <Row>
            <Col style={{ width: "100%", marginBottom: "10px" }}>
              <label htmlFor="position" className="labelInput">
                Job Position <span style={{ color: "red" }}>*</span>
              </label>
              <Form.Item
                name="position"
                rules={[
                  {
                    required: true,
                    message: "Job Position is required",
                  },
                ]}
              >
                <Input className="inputForm" />
              </Form.Item>
            </Col>
          </Row>
          <Row>
            <Col span={8}>
              <label htmlFor="contact" className="labelInput">
                Contact <span style={{ color: "red" }}>*</span>
              </label>
              <div
                className="inputForm"
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  width: "90%",
                  marginRight: "8px",
                  height: "42px",
                }}
              >
                <img
                  src={icon_malaysia}
                  alt="country"
                  style={{ marginTop: "3px" }}
                />
                <span style={{ marginLeft: "7px", marginTop: "3px" }}>+60</span>
              </div>
            </Col>
            <Col span={16}>
              <Form.Item
                name="contact"
                rules={[
                  {
                    required: true,
                    message: "Contact is required",
                  },
                ]}
              >
                <InputNumber
                  className="inputForm inputNumber"
                  maxLength="10"
                  style={{ backgroundColor: "transparent" }}
                  controls={false}
                  inputMode="numeric"
                  step={null}
                  formatter={formatInput}
                  parser={parseInput} 
                  onKeyPress={handleKeyPress}
                />
              </Form.Item>
            </Col>
          </Row>
          <Row>
            <Col style={{ width: "100%", marginBottom: "10px" }}>
              <label htmlFor="email" className="labelInput">
                Email <span style={{ color: "red" }}>*</span>
              </label>
              <Form.Item
                name="email"
                rules={[
                  {
                    required: true,
                    message: "Email is required",
                  },
                ]}
              >
                <Input
                  className="inputForm"
                  type="email"
                  placeholder={type === "create" ? "example@example.com" : ""}
                  suffix={
                    type === "edit" && (
                      <LockOutlined style={{ color: "#D9D9D9" }} />
                    )
                  }
                  readOnly={type === "edit"}
                />
              </Form.Item>
            </Col>
          </Row>

          {type === "create" && (
            <>
              <Row>
                <Col style={{ width: "100%", marginBottom: "10px" }}>
                  <Form.Item>
                    <Row
                      style={{
                        color: "#c8c8c8",
                        alignItems: "center",
                        fontSize: "15px",
                        marginLeft: "2%",
                      }}
                    >
                      <Col style={{ textAlign: "left", width: "100%" }}>
                        Login Credential
                      </Col>
                    </Row>
                  </Form.Item>
                </Col>
              </Row>
              <Row>
                <Col style={{ width: "100%", marginBottom: "10px" }}>
                  <label htmlFor="password" className="labelInput">
                    Password <span style={{ color: "red" }}>*</span>
                  </label>
                  <Form.Item
                    name="password"
                    hasFeedback
                    rules={[
                      {
                        required: true,
                        message: "Password required",
                      },
                      {
                        min: 8,
                        message: "Password must be at least 8 characters long",
                      },
                      {
                        pattern: /[A-Z]/,
                        message:
                          "Password must contain at least one uppercase letter",
                      },
                      {
                        pattern: /\d/,
                        message: "Password must contain at least one number",
                      },
                    ]}
                  >
                    <Input.Password className="inputForm" />
                  </Form.Item>
                </Col>
              </Row>
              <Row>
                <Col style={{ width: "100%", marginBottom: "10px" }}>
                  <label htmlFor="confirmPassword" className="labelInput">
                    Confirm Password <span style={{ color: "red" }}>*</span>
                  </label>
                  <Form.Item
                    name="confirmPassword"
                    dependencies={["password"]}
                    hasFeedback
                    rules={[
                      {
                        required: true,
                        message: "Password required",
                      },
                      ({ getFieldValue }) => ({
                        validator(_, value) {
                          if (!value || getFieldValue("password") === value) {
                            return Promise.resolve();
                          }
                          return Promise.reject(
                            new Error("Passwords do not match!")
                          );
                        },
                      }),
                    ]}
                  >
                    <Input.Password className="inputForm" />
                  </Form.Item>
                </Col>
              </Row>
            </>
          )}
        </Form>
      </Drawer>
    </>
  );
};

export default DrawerEmployer;
